// @flow
import React, { useCallback, useContext, useState, type Node, type ComponentType } from 'react';
import nest from 'recompose/nest';

import OrderPostApi, { OrderPost, type RequestDataProps, type OrderPostState, type OrderPostProps } from 'app/common/components/Shop/OrderPostApi';


type Props = {
  data: RequestDataProps, // -> OrderPostApi
  onCheckErrors: () => boolean,
  onSuccess: () => Promise<void> | () => void,
  children: (
    handleSubmit: (e: SyntheticEvent<HTMLElement>) => Promise<void>,
    submitting: boolean
  ) => Node,
}

const SubmitOrder = ({ onCheckErrors, onSuccess, children }: Props) => {
  const { request: { orderPost } }: OrderPostState = useContext(OrderPost);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!onCheckErrors()) {
      return;
    }
    setSubmitting(true);
    const res = await orderPost();
    setSubmitting(false);
    if (res) {
      onSuccess();
    }
  }, [orderPost, onCheckErrors, onSuccess]);

  return (
    <div>
      {children(handleSubmit, submitting)}
    </div>
  );
};

const Nested: ComponentType<{ ...Props, ...OrderPostProps }> = nest(OrderPostApi, SubmitOrder);
export default Nested;
